import { Injectable } from '@angular/core';

import { ContentfulClientApi, createClient, Entry } from 'contentful';
import { environment } from '../../environments/environment';
import { ContentfulEntryType as ContentfulEntryTypeHelp} from '@generativ/ms-help-types';
import { ContentfulEntryType } from '@generativ/ms-student-types';

@Injectable({ providedIn: 'root' })
export class ContentfulService {

  private studentClient = createClient({
    space: environment.contentful.space,
    accessToken: environment.contentful.accessToken
  });

  private helpClient = createClient({
    space: environment.contentful.help.space,
    accessToken: environment.contentful.help.accessToken
  });

  entryCache: Map<string, any>;
  entryHelpCache: Map<string, any>;

  constructor() {
    this.entryCache = new Map<string, any>();
    this.entryHelpCache = new Map<string, any>();
  }

  getStudentEntry(id: string): Promise<ContentfulEntryType> {
    // Contentful returns a promise but it is not an angular Promise
    // which means the UI won't update and it won't work with async functions.
    // For this reason we wrap it in its own promise
    return new Promise<ContentfulEntryType>((resolve, reject) => {
      if (this.entryCache.has(id)) {
        resolve(this.entryCache.get(id));
        return;
      }

      this.studentClient.getEntry(id, {
        include: 7
      }).then((entry: any) => {
        if (entry) {
          resolve(entry);
        }
        reject('Entry not found');
      }).catch((error) => {
        reject(error);
      });
    });
  }


  getHelpEntry(id: string): Promise<ContentfulEntryTypeHelp> {
    // Contentful returns a promise but it is not an angular Promise
    // which means the UI won't update and it won't work with async functions.
    // For this reason we wrap it in its own promise
    return new Promise<ContentfulEntryTypeHelp>((resolve, reject) => {
      if (this.entryHelpCache.has(id)) {
        resolve(this.entryHelpCache.get(id));
        return;
      }

      this.helpClient.getEntries({
        'sys.id': id,
        include: 7
      }).then((entries: any) => {
        const entry = this.extractOneEntry(entries);

        if (entry) {
          resolve(entry);
        }
        reject('Entry not found');
      }).catch((error) => {
        reject(error);
      });
    });
  }

  private extractOneEntry(entries: any): ContentfulEntryTypeHelp {
    if (!entries || entries.items < 1) {
      return null;
    }
    // Redundant but removes error in WebStorm for entries.items[0]
    const items: ContentfulEntryTypeHelp[] = entries.items;
    const rawEntry: ContentfulEntryTypeHelp = items[0];
    console.log(rawEntry);
    rawEntry.includes = entries.hasOwnProperty('includes') ? entries.includes : null;
    // console.log('Includes', includes);

    if (rawEntry) {
      const entry: ContentfulEntryTypeHelp = rawEntry;
      // console.log('Entry', entry);
      this.entryHelpCache.set(entry.sys.id, entry);
      // console.log(entry);
      return entry;
    }
    return null;
  }
}
